import { api } from './client'

export interface RedditEmbedInfo {
  youtube_video_id: string | null
}

export function fetchRedditEmbedInfo(url: string): Promise<RedditEmbedInfo> {
  return api.get<RedditEmbedInfo>(`/reddit-embed?url=${encodeURIComponent(url)}`)
}
